//angular imports
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  OnDestroy,
  signal,
  Signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { ModuleNavigatedMessage } from "@app/core";
import {
  CatalogHeaderModel,
  CatalogDataChangedMessage,
  CatalogMenuModel,
  ExportPackageMessage,
  ExportPackageModel,
  ExitPropertyPageMessage,
} from "@app/catalog";
import { CloseDialogMessage, Messenger } from "@app/shared";
import { CommonConstants } from "@app/app-common";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { filter, map, startWith } from "rxjs";

@Component({
  selector: "catalog-dashboard",
  templateUrl: "./catalog-dashboard.component.html",
  styleUrl: "./catalog-dashboard.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CatalogDashboardComponent implements AfterViewInit, OnDestroy {

  private moduleNavigatedMsg: Signal<ModuleNavigatedMessage>;
  private catalogMenuChangedMsg: Signal<CatalogDataChangedMessage>;
  public tabData: WritableSignal<any[]> = signal<any[]>([]);
  private urlSignal = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url)
    )
  );

  public isPropertiesPage = computed(() => {
    const parts = this.urlSignal()?.split('/').filter(part => part.length > 0) ?? [];
    return parts.length >= 3 && parts[0] === CommonConstants.CATALOG;
  });

  public constants = CommonConstants;  

  constructor(
    private messenger: Messenger,
    private route: ActivatedRoute, 
    private router: Router) {
    this.moduleNavigatedMsg = this.messenger.getSignal(ModuleNavigatedMessage);
    this.catalogMenuChangedMsg = this.messenger.getSignal(CatalogDataChangedMessage);

    this.setupMessengerSubscriptions();
  }

  ngAfterViewInit(): void {
    const menuModel = new CatalogMenuModel();
    menuModel.initialize(this.messenger, this.moduleNavigatedMsg, this.catalogMenuChangedMsg);
    
    this.messenger.send(
      new ModuleNavigatedMessage(
        new CatalogHeaderModel(),
        menuModel
      ),
    );
  }

  private setupMessengerSubscriptions(): void {
    this.messenger.subscribe(this, ExportPackageMessage, (msg) => {
      const model = new ExportPackageModel(msg.project);
      this.tabData.set([model]);
    });


    this.messenger.subscribe(this, CloseDialogMessage, () => {
      this.tabData.set([]);
    });
  }
  

  public navigateToListPage() {
    const currentQueryParams = this.route.snapshot.queryParams;
    this.messenger.send(new ExitPropertyPageMessage());
    
    this.router.navigate(["/catalog"], {
      queryParams: currentQueryParams,
      queryParamsHandling: "merge",
    });
  }


  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}
